import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmailPlus: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="email-plus, envelope, add, plus"><path d="M12.75 19.25H2.75V4.75H21.25V10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3 5.63635L12 11L21 5.63635" stroke="currentColor" strokeWidth="1.5"/><path d="M19 13.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M22.25 17L15.75 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconEmailPlus;
